import { useMutation } from '@tanstack/react-query'
import { postAsync } from '@/helpers/http-request'
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

type ForgotPasswordData = {
  email: string;
}

const useForgotPassword = (returnUrl: string) => {
  const { t } = useTranslation();

  const forgotPasswordMutation = useMutation({
    mutationFn: async (data: ForgotPasswordData): Promise<void> => {
      const response = await postAsync(`/web/v1/user/forgotPassword?returnUrl=${returnUrl}`, data);
      if (!response.ok) {
        throw new Error('serverError');
      }
    },
    onError: (__error): void => {
      toast.error(t('errors.serverError'));
    }
  });

  return {
    sendResetEmail: forgotPasswordMutation.mutateAsync,
    isLoading: forgotPasswordMutation.isPending,
    isSuccess: forgotPasswordMutation.isSuccess,
    isError: forgotPasswordMutation.isError,
    reset: forgotPasswordMutation.reset,
  };
}

export default useForgotPassword;